// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"4d3451f1","133":"c261811d","161":"4d3451f1","349":"7783d9ad","359":"aeb67f96","471":"66d66f6d","506":"4d3451f1","549":"13c8883b","625":"4d3451f1","672":"4d3451f1","757":"4d3451f1","836":"4d3451f1","844":"4d3451f1","958":"9823f715"}[chunkId] + ".chunk.css";
};